import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "role"]

  connect() {
    this.initialRole = this.roleTarget?.value
  }

  roleChanged(event) {
    if (event.target.value === "owner" && this.initialRole !== "owner") {
      event.preventDefault()
      this.showModal()
    }
  }

  showModal() {
    const modal = document.getElementById("owner-confirmation-modal")
    if (modal) modal.classList.remove("hidden")
  }

  confirmAndSubmit() {
    const modal = document.getElementById("owner-confirmation-modal")
    if (modal) modal.classList.add("hidden")
    // Keep owner, do nothing else
  }

  cancel() {
    window.location.reload()
  }
}
